const EXPANDED_TOGGLE_TEXT = 'Vis kun vanligste';

class TaxonomyWidget {
    constructor(rootElement) {
        this._rootEle = rootElement;
        const toggleButton = rootElement.querySelector('[data-toggle]');
        this._defaultToggleText = toggleButton && toggleButton.textContent;

        rootElement.addEventListener('click', event =>
            this._handleTogglePopular(event)
        );
        rootElement.addEventListener('change', event =>
            this._handleChange(event)
        );
    }

    _getNode(ele) {
        return ele.closest('li');
    }

    _getBranch(ele) {
        return ele.querySelector('ul');
    }

    /**
     * Toggle all branches of a children children that has a is-not-popular flag set
     */
    _togglePopularChildren(ele, expand) {
        [...ele.children]
            .filter(ele => ele.matches('[data-is-not-popular]'))
            .filter(ele => !ele.querySelector(':checked')) // If a descendent is checked, don't toggle
            .forEach(ele => ele.classList.toggle('hidden', expand));
    }

    /**
     * Open a branch
     */
    _openBranch(ele) {
        ele.classList.remove('hidden');
    }

    /**
     * Close a branch and all child branches and uncheck all child nodes
     */
    _closeBranch(ele) {
        [...ele.querySelectorAll('input')].forEach(ele => {
            ele.checked = false;
            ele.indeterminate = false;
        });

        const elesToHide = [
            ...ele.querySelectorAll('ul, [data-is-not-popular]'),
        ];
        if (ele !== this._rootEle) {
            elesToHide.push(ele);
        }
        elesToHide.forEach(ele => {
            ele.classList.add('hidden');
            const toggleButton = ele.querySelector('[data-toggle]');
            if (toggleButton) {
                toggleButton.removeAttribute('data-expanded');
            }
        });
    }

    _handleChange(event) {
        const nodeEle = this._getNode(event.target);
        const branchEle = this._getBranch(nodeEle);
        if (branchEle) {
            if (event.target.checked) {
                this._openBranch(branchEle);
            } else {
                this._closeBranch(branchEle);
            }
        }
    }

    _handleTogglePopular(event) {
        const toggleButton = event.target.closest('[data-toggle]');
        if (toggleButton && event.currentTarget.contains(toggleButton)) {
            const parentBranch = toggleButton.closest('ul');
            const isExpanded =
                toggleButton.getAttribute('data-expanded') === 'true';
            this._togglePopularChildren(parentBranch, isExpanded);
            if (isExpanded) {
                if (parentBranch.scrollIntoViewIfNeeded) {
                    parentBranch.scrollIntoViewIfNeeded();
                } else {
                    parentBranch.scrollIntoView();
                }
            }
            toggleButton.setAttribute('data-expanded', !isExpanded);
            // TODO: Is this wrong? Expanded does not give expanded toggle text. Might just be weird name
            toggleButton.textContent = isExpanded
                ? this._defaultToggleText
                : EXPANDED_TOGGLE_TEXT;
            event.preventDefault();
            event.stopPropagation();
        }
    }

    reset() {
        this._closeBranch(this._rootEle);
    }
}

export default TaxonomyWidget;



// WEBPACK FOOTER //
// ./lib/search/TaxonomyWidget.js